import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo, useState } from "react";
import { CredentialsProvider } from "../";
import { SaleorManager } from "../../../";
import { SaleorContext } from "../../context";
export function SaleorProvider(_ref) {
  var client = _ref.client,
      config = _ref.config,
      children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      context = _useState2[0],
      setContext = _useState2[1];

  useMemo(function () {
    var manager = new SaleorManager(client, config);
    manager.connect(function (saleorAPI) {
      return setContext(_objectSpread({}, saleorAPI));
    });
    return manager;
  }, [client]);
  return React.createElement(SaleorContext.Provider, {
    value: context
  }, context ? React.createElement(CredentialsProvider, null, children) : React.createElement(React.Fragment, null));
}